export default __webpack_public_path__ + "resources/icons/d311-aba3.webp";